import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Toolbar, IconButton } from '@mui/material';
import { useSelector } from 'react-redux';
//import NotificationsIcon from '@mui/icons-material/Notifications';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

import Image from '../../Image';
import AccountBadge from '../../Navbar/components/AccountBadge';
import NotificationsBadge from '../../Navbar/components/NotificationsBadge';
// import SeparatorVertical from '../../SeparatorVertical';
import { ReactComponent as SplitLogo } from '../../../assetsNew/logo.svg';
// import { localeFormatCurrency, isEmptyValue } from '../../../utils/custom';

import './_dashboardNav.scss';

const DashboardNav = ({ open, toggleDrawer }) => {
  const [anchorEl, setAnchorEl] = useState({ account: null, notifications: null });
  //const { data } = useSelector(s => s.notifications);
  const { data: { avatar_url } } = useSelector(s => s.account);
  const { unreadMessagesCount } = useSelector(s => s.sendbirdUnreadMessages);
  // const { data: { available_cents } } = useSelector(s => s.getBillingCreditsBalance);

  const handleMenuOpen = (key, event) => setAnchorEl({ ...anchorEl, [key]: event.currentTarget });
  const handleMenuClose = key => setAnchorEl({ ...anchorEl, [key]: null });

  const renderAccountBadge = () => <AccountBadge closeMenu={() => handleMenuClose('account')} anchorEl={anchorEl.account} />;
  const renderNotificationsBadge = () => <NotificationsBadge closeMenu={() => handleMenuClose('notifications')} anchorEl={anchorEl.notifications} />;

  return (
    <div className="dashboardNav">
      <Toolbar classes={{ regular: 'regular-toolbar' }}>
        <IconButton onClick={toggleDrawer()} edge="start" className="menu-button" color="inherit">
          {!open ? <MenuIcon /> : <ChevronLeftIcon />}
          {Boolean(unreadMessagesCount) && !open && <div className="menu-button-unread-dot" />}
        </IconButton>
        <div className="center">
          <SplitLogo className="logo-image" />
        </div>
        <div className="right">
          {/*<IconButton color="inherit" onClick={e => handleMenuOpen('notifications', e)}>
            <Badge badgeContent={data.length} color="secondary">
              <NotificationsIcon />
            </Badge>
          </IconButton>*/}
            {/*{!isEmptyValue(available_cents) && (*/}
            {/*  <>*/}
            {/*    <div className="credits">*/}
            {/*      <p className="credits-label">Available credits</p>*/}
            {/*      <p className="credits-value">{localeFormatCurrency({ value: available_cents / 100, minDigits: 0 })}</p>*/}
            {/*    </div>*/}
            {/*    <SeparatorVertical />*/}
            {/*  </>*/}
            {/*)}*/}
            <div className="user" onClick={e => handleMenuOpen('account', e)}>
            <Image className="avatar" image_url={avatar_url} alt="avatar" />
          </div>
        </div>
      </Toolbar>
      {renderAccountBadge()}
      {renderNotificationsBadge()}
    </div>
  );
};

DashboardNav.propTypes = {
  open: PropTypes.bool.isRequired,
  toggleDrawer: PropTypes.func.isRequired
};

export default DashboardNav;